import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Container } from '@mui/material';
import SideBarNav from '../../../../Layout/SideBarNav/SideBarNav';

import AddBankPage from './AddBankPage';
import UpdateBankPage from './UpdateBankPage';

// import AddBankPage from '../Pages/AddBankPage';
// import AddBankForm from './AddBankForm';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      // sx={{flexGrow: 1, p: 85, ml:'10vh' }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3}}>
          {/* <Box>{children}</Box> */}
          <Typography  component={"div"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AddUpdateHQBankTabsPage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>

        <SideBarNav/>
        <Container >
            <Box sx={{ width: '100%'}}>
            {/* , flexGrow: 1, p: 85, ml:'10vh'  */}
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Add Headquarter Bank" {...a11yProps(0)} />
                    <Tab label="Update Headquarter Bank" {...a11yProps(1)} />
                  </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                  <AddBankPage/>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                  <UpdateBankPage/>
              </CustomTabPanel>
            </Box>
        </Container>
    
    </>
  );
}